import MemoryStore from '../utils/memory-store'
import { formatRecordData } from '../utils/utilities'
import BatchActionsFormContainer from '../batch-actions/containers/batch-actions-form-container'
import Enums from '../utils/enums'

export const filterViewData = (viewData, searchFilter) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return viewData
  } else {
    return viewData.filter(
      t =>
        t.data.key.toLowerCase().indexOf(searchFilter) > -1 ||
        t.data.description.toLowerCase().indexOf(searchFilter) > -1
    )
  }
}

export const filterActionsViewData = (data, searchFilter, callback) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return callback(data)
  } else {
    return callback(
      data.filter(
        t =>
          t.description.toLowerCase().indexOf(searchFilter) > -1
      )
    )
  }
}

export const getConnectorProfiles = callback => {
  MemoryStore.agilite.Connectors.getData()
    .then((response) => {
      callback(null, response)
    })
    .catch((error) => {
      callback(error, null)
    })
}

export const formatRecord = (entry, data) => {
  let tempIndex = 0

  entry = formatRecordData(entry)

  if (entry.data.isActive !== undefined) {
    entry.data.isActiveDescription = entry.data.isActive ? 'Yes' : 'No'
  }

  if (entry.custom.isNewDoc) {
    // Add new Entry to State
    entry.custom.isNewDoc = false
    entry.custom.action = 'create'
    data.push(entry)
  } else {
    if (entry.custom.isSavedDoc) {
      entry.custom.action = 'update'
    } else {
      entry.custom.action = 'create'
    }

    // Update Entry in State
    tempIndex = data.findIndex(t => t._id === entry._id)
    data[tempIndex] = entry
  }

  return data
}

export const createCopy = (currEntryData, callback) => {
  const newEntry = JSON.parse(JSON.stringify(MemoryStore.batchactions.dataTemplate))
  newEntry._id = new Date().getTime().toString()
  newEntry.custom.tempId = newEntry._id

  const entryData = JSON.parse(JSON.stringify(currEntryData))
  const tabType = Enums.VALUES_STRINGS.FORM
  const content = BatchActionsFormContainer
  const closable = true
  const key = newEntry._id
  const app = Enums.APP_IDS.BATCH_ACTIONS

  let title = Enums.APP_PROFILE_TITLES.batchactions + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE
  let payload = {}

  // create unique key
  entryData.key = currEntryData.key + '_copy'

  newEntry.data = entryData

  title += entryData.key

  payload = {
    content,
    title,
    key,
    app,
    tabType,
    closable
  }

  MemoryStore.activeEntries[newEntry._id] = newEntry

  callback(payload)
}
